import axios from 'axios';
import {
    USERJOB_GET_ONE,
    USERJOB_GET_MULTIPLE,
    USERJOB_REGISTER_SUCCESS,
    USERJOB_REGISTER_FAIL,
    USERJOB_LOADING,
    USERJOB_LOADING_ERROR,
    USERJOB_UPDATE_SUCCESS,
    USERJOB_UPDATE_FAIL,
    USERJOB_DELETE_SUCCESS,
    USERJOB_DELETE_FAIL,
    USERJOB_EDIT,
} from "./../types/userjob";
import { MAIN_TOKEN, SERVER_PATHS, axiosConfig1, axiosConfig } from './common';

let TABLE_NAME = 'userjobs';
const path = SERVER_PATHS + '/staff.php';;

let params = {
    data:{},
    cat:'all',
    table:TABLE_NAME,
    token:MAIN_TOKEN
  }
//GET ALL USERJOB 
export const getUserjobs = params => (dispatch, getState) => {
    //SET PAGE LOADING
    params.token = MAIN_TOKEN;
    dispatch({type : USERJOB_LOADING});
        axios.get(path, {params}, axiosConfig)
            .then(res => {                                                                                                                                                                                                                                        
                dispatch({
                    type: USERJOB_GET_MULTIPLE,
                    payload: res.data
                })
            })
            .catch(err => {
                dispatch({
                    type : USERJOB_LOADING_ERROR,
                    payload:err
                })
            })
};
//GET SINGLE USERJOB 
export const getUserjob = id => (dispatch, getState) => {
    //SET PAGE LOADING
    dispatch(
        {
        type : USERJOB_GET_ONE,
        payload: id
    });  
};
//USERJOB DELETE
export const deleteUserjob = dat => (dispatch, getState) =>{
    
    params.data = dat;
    params.cat = 'deleter';
    axios.get(path, {params}, axiosConfig)
        .then(res => {
            dispatch({
                type: USERJOB_DELETE_SUCCESS,
                payload: dat.id
            })
        })
        .catch(err => {
            dispatch({
                type : USERJOB_DELETE_FAIL,
                payload : err
            })
        })
        
}
//USERJOB REGISTER
export const registerUserjob = data => dispatch => {   
    axios.post(path, data, axiosConfig1)
        .then(res => {
            dispatch({
                type: USERJOB_REGISTER_SUCCESS,
                payload: res.data.data
            })
        })
        .catch(err => {
            dispatch({
                type : USERJOB_REGISTER_FAIL,
                payload: err
            })
        })
};
 //USERJOB UPDATE
export const updateUserjob = (data) => (dispatch, getState) => {
    //body
    axios.post(path, data, axiosConfig1)
        .then(res => {
            dispatch({
                type: USERJOB_UPDATE_SUCCESS,
                payload: res.data.data
            })
        })
        .catch(err => {
            dispatch({
                type : USERJOB_UPDATE_FAIL,
                payload: err
            })
        })
};
